import { useLocation, useNavigate } from 'react-router-dom';
import { CustomButtonGroup } from '@components/Styles/CommonStyle';
import { CustomTabButton } from '@components/Styles/ButtonStyle';
import React, { useMemo } from 'react';

const TabNavigation = ({ segment }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const buttonInfo = useMemo(
    () => ({
      project: [
        { id: 'project', text: '사업 현황', path: '/project/projectList' },
        { id: 'plannedProject', text: '예정 사업', path: '/project/PlannedProjectList' },
        { id: 'sales', text: '매출매입관리', path: '/project/salesPurchaseManagement' },
      ],
      account: [
        { id: 'corporation', text: '법인사업자', path: '/account/companyAccountList' },
        { id: 'individual', text: '개인사업자', path: '/account/selfAccountList' },
        { id: 'freelancer', text: '프리랜서', path: '/account/freeAccountList' },
      ],
      setting: [{ id: 'userManagement', text: '사용자관리', path: '/setting/userList' }],
    }),
    [],
  );

  const buttonData = buttonInfo[segment] || [];

  const buttons = useMemo(
    () =>
      buttonData.map((button) => (
        <CustomTabButton
          key={button.id}
          onClick={() => navigate(button.path)}
          variant={location.pathname === button.path ? 'contained' : 'outlined'}
        >
          {button.text}
        </CustomTabButton>
      )),
    [buttonData, location.pathname, navigate],
  );

  if (buttonData.length === 0) return null;

  return <CustomButtonGroup aria-label="네비게이션 탭">{buttons}</CustomButtonGroup>;
};

export default TabNavigation;
